module.exports = __webpack_public_path__ + "img/go1.ae5a2a37.png";